/**
 * Configure and register global directives
 */
import type { App } from 'vue';
import { PADMode } from '@mts/utils/env';
import hiddenDirective from './hidden';
import langTipsDirective from './langTips';
import loadingDirective from './loading';
import authDirective from './permission';
import pressCopyDirective from './pressCopy';

export function setupGlobDirectives(app: App) {
  app.directive('langTips', langTipsDirective);
  app.directive('loading', loadingDirective);
  app.directive('auth', authDirective);
  app.directive('hidden', hiddenDirective);
  PADMode && app.directive('pressCopy', pressCopyDirective);
}
